/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBatteryVerticalEco = createReactComponent("outline", "battery-vertical-eco", "IconBatteryVerticalEco", [["path", { "d": "M7 18v-11c0 -1.105 .895 -2 2 -2h.5c.276 0 .5 -.224 .5 -.5s.224 -.5 .5 -.5h3c.276 0 .5 .224 .5 .5s.224 .5 .5 .5h.5c1.105 0 2 .895 2 2v1m-8 12c-1.105 0 -2 -.895 -2 -2", "key": "svg-0" }], ["path", { "d": "M13 17.143c0 -2.84 2.09 -5.143 4.667 -5.143h2.333v.857c0 2.84 -2.09 5.143 -4.667 5.143h-2.333z", "key": "svg-1" }], ["path", { "d": "M13 21v-3", "key": "svg-2" }]]);

export { IconBatteryVerticalEco as default };
//# sourceMappingURL=IconBatteryVerticalEco.mjs.map
